//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeEditApi, noticeEditCreateApi, noticeSaveApi } from '@/api/administration';
export default {
  name: 'AddNotice',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    uploadPicture: function uploadPicture() {
      return import('@/components/uploadPicture/index');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    }
  },
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        title: '',
        categoryId: '',
        info: '',
        imageUrl: '',
        content: '',
        delivery: false,
        resource: 0,
        date: '',
        contents: ''
      },
      expireTimeOption: {
        disabledDate: function disabledDate(date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      rules: {
        title: [{
          required: true,
          message: '请输入公告标题',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择公告分类',
          trigger: 'change'
        }],
        contents: [{
          required: true,
          message: '请输入公告正文',
          trigger: 'change'
        }]
      },
      isImage: false,
      srcList: []
    };
  },
  mounted: function mounted() {
    this.$erd.listenTo(this.$refs.notice, function (element) {
      var h = document.documentElement.clientHeight;
      h = h - 28 - 54 - 58;
      element.style.height = h + 'px';
    });
  },
  watch: {},
  methods: {
    beforeUpload: function beforeUpload() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.uploadPicture.getFileList('');
      this.$refs.uploadPicture.selectItem = [];
      this.$refs.uploadPicture.checkPicList = [];
    },
    getImage: function getImage(data) {
      this.form.imageUrl = data.att_dir;
      this.handleClose();
    },
    handleAvatar: function handleAvatar() {
      this.form.imageUrl = '';
    },
    reset: function reset() {
      this.form = {
        title: '',
        categoryId: '',
        info: '',
        imageUrl: '',
        content: '',
        delivery: false,
        resource: 0,
        date: '',
        contents: ''
      };
      this.$refs.ueditorFrom.clear();
      this.$refs.form.resetFields();
    },
    // 监听编辑器
    ueditorEdit: function ueditorEdit(e) {
      this.form.contents = e;
      if (e) {
        this.$refs.form.validateField('contents');
      }
    },
    handleEmit: function handleEmit() {
      this.reset();
      this.form.contents = '';
      this.$emit('isNotice');
    },
    handleCancel: function handleCancel() {
      this.handleEmit();
      this.$refs.ueditorFrom.clear();
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.form.contents = this.$refs.ueditorFrom.getValue();
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var data = {
            cate_id: _this.form.categoryId,
            title: _this.form.title,
            info: _this.form.info,
            cover: _this.form.imageUrl,
            content: _this.form.contents,
            is_top: _this.form.delivery ? 1 : 0,
            push_type: _this.form.resource,
            push_time: _this.$moment(_this.form.date).format('YYYY-MM-DD HH:mm:ss')
          };
          if (_this.formData.isEdit) {
            _this.getNoticeEdit(_this.formData.id, data);
          } else {
            _this.getNoticeSave(data);
          }
        }
      });
    },
    // 保存
    getNoticeSave: function getNoticeSave(data) {
      var _this2 = this;
      this.loading = true;
      noticeSaveApi(data).then(function (res) {
        _this2.loading = false;
        _this2.reset();
        _this2.handleEmit();
      }).catch(function (error) {
        _this2.loading = false;
      });
    },
    // 编辑
    getNoticeEdit: function getNoticeEdit(id, data) {
      var _this3 = this;
      this.loading = true;
      noticeEditApi(id, data).then(function (res) {
        _this3.loading = false;
        _this3.reset();
        _this3.handleEmit();
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    getNoticeCreate: function getNoticeCreate(id) {
      var _this4 = this;
      noticeEditCreateApi(id).then(function (res) {
        var data = res.data;
        _this4.form.categoryId = data.cate_id;
        _this4.form.title = data.title;
        _this4.form.info = data.info;
        _this4.form.imageUrl = data.cover;
        _this4.$refs.ueditorFrom.tabButton = true;
        _this4.form.content = data.content;
        _this4.form.contents = data.content;
        _this4.form.delivery = data.is_top === 1;
        _this4.form.resource = data.push_type;
        if (data.push_type === 0) {
          _this4.form.date = '';
        } else {
          _this4.form.date = data.push_time;
        }
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview() {
      this.srcList.push(this.form.imageUrl);
      this.isImage = true;
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    }
  }
};